import { AxiosResponse } from "axios";
import moment from "moment";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { IS_RETAILER } from "../../../../utils/Api";
import { get } from "../../../../utils/request";
import { chargesForEnum } from "../../shipping/types";
import {
  selectEndDate,
  selectFilterValue,
  selectStartDate
} from "./selector";
import { actions } from "./slice";

export function* getDashboardListRequest() {
  yield delay(500);
  const dateFIlter: number = yield select(selectFilterValue);
  const startDate: Date | string = yield select(selectStartDate);
  const endDate: Date | string = yield select(selectEndDate);

  try {
    const response: AxiosResponse = yield call(
      get,
      `admin/dashboard/get/data/${
        IS_RETAILER =="true" ? chargesForEnum.RETAILER : chargesForEnum.USER
      }?dateFilter=${dateFIlter == -1 ? "" : dateFIlter}&startDate=${
        startDate !== "" && dateFIlter == -1
          ? moment(startDate).format("YYYY/MM/DD")
          : ""
      }&endDate=${
        endDate !== "" && dateFIlter == -1
          ? moment(endDate).format("YYYY/MM/DD")
          : ""
      }`
    );
    if (response && response.data.status == false) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setDashboardsList(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* getDashboardChartDataRequest() {
  yield delay(500);
  const dateFIlter: number = yield select(selectFilterValue);
  const startDate: Date | string = yield select(selectStartDate);
  const endDate: Date | string = yield select(selectEndDate);
  try {
    const response: AxiosResponse = yield call(
      get,
      `admin/dashboard/dashboard-graph/${
        IS_RETAILER =="true"  ? chargesForEnum.RETAILER : chargesForEnum.USER
      }?dateFilter=${dateFIlter == -1 ? "" : dateFIlter}&startDate=${
        startDate !== "" && dateFIlter == -1
          ? moment(startDate).format("YYYY/MM/DD")
          : ""
      }&endDate=${
        endDate !== "" && dateFIlter == -1
          ? moment(endDate).format("YYYY/MM/DD")
          : ""
      }`
    );
    if (response && response.data.status == false) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setChartData(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* DashboardRepoSaga() {
  yield takeLatest(actions.doGetDashboardList, getDashboardListRequest);
  yield takeLatest(actions.getDashboardChartData, getDashboardChartDataRequest);
}
